import { render, staticRenderFns } from "./UserTaskDetail.vue?vue&type=template&id=3adb8b59&"
import script from "./UserTaskDetail.vue?vue&type=script&lang=js&"
export * from "./UserTaskDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports